import { useQuery } from '@tanstack/react-query';
import { getAllProviderFormatsAvailableByFormatId } from '../../api/providerFormatApi';

export const useGetAllProvidersFormatByFormatId = (formatId, filters) => {
  return useQuery(['provider-formats-availables', formatId], () =>
    getAllProviderFormatsAvailableByFormatId(formatId, filters),
  );
};
